import React, { PropsWithChildren } from "react";
import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import { FormControl, FormHelperText, FormLabel, ToggleButton } from "@mui/material";

import { CommonFieldProps } from "./types";
import { FormToggleButtonGroup } from "components/theme/buttons/form.toggle.button.group";

interface Props<T extends FieldValues> extends CommonFieldProps<T> {
    control: Control;
    options: any[];
    labelId: string;
    label: string;
    exclusive?: boolean;
}

const FieldToggleButtonGroup: React.FunctionComponent<Props<any>> = <TObject extends FieldValues>({
    control,
    fieldName,
    options,
    labelId,
    label,
    exclusive = false,
    children,
}: PropsWithChildren<Props<TObject>>) => (
    <Controller
        name={fieldName}
        control={control}
        defaultValue={(exclusive ? '' : []) as PathValue<TObject, Path<TObject>>}
        render={({ field: {onChange, ..._field}, fieldState: {error} }) => (
            <FormControl fullWidth margin="normal" error={error !== undefined}>
                <FormLabel id={labelId}>{label}</FormLabel>
                <FormToggleButtonGroup exclusive={exclusive} color='info' size='small' {..._field} onChange={(event, value) => onChange(value)}>
                    {options.map((val) => (
                        <ToggleButton value={Array.isArray(val) ? val[0] : val} key={Array.isArray(val) ? val[0] : val}>
                            {Array.isArray(val) ? val[1] : val}
                        </ToggleButton>
                    ))}
                </FormToggleButtonGroup>
                {error && <FormHelperText id={labelId}>{error.message}</FormHelperText>}
            </FormControl>
        )}
    />
);

export default FieldToggleButtonGroup;